module.exports = __webpack_public_path__ + "static/media/GK-Fashion-Logo.138d1c5c.png";